import React, { useContext } from 'react';
import classnames from 'classnames';
import { bool } from 'prop-types';
import { Placeholder } from '@thd-olt-component-react/core-ui';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import './packages-mini-loader.scss';

export const PackagesMiniPlaceholder = ({ isPackageLite }) => {
  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';
  const loadingArr = new Array(6).fill(null);

  const mainPlaceholderClasses = classnames('packages-mini-loader__main', {
    // Accounting for bundling products tab hiding its info section when channel is mobile
    'packages-mini-loader__main--mobile': isMobile,
  });
  const litePlaceholderClasses = classnames('packages-mini-loader__lite', {
    'packages-mini-loader_lite--mobile': isMobile,
  });

  return (
    isPackageLite ? (
      <Placeholder className={litePlaceholderClasses} type="rect" />
    ) : (
      <div className="packages-mini-loader">
        <Placeholder className={mainPlaceholderClasses} />
        <div className="packages-mini-loader__tabs">
          {loadingArr.map((_, key) => (
            <Placeholder
              className="packages-mini-loader__tab"
              height="85px"
              key={`loadingPlaceholder-${key}`}
            />
          ))}
        </div>
      </div>
    )
  );
};

PackagesMiniPlaceholder.propTypes = {
  isPackageLite: bool
};
PackagesMiniPlaceholder.defaultProps = {
  isPackageLite: false
};

PackagesMiniPlaceholder.displayName = 'PackagesMiniPlaceholder';
